export type IssuerIdentity = {
  accent: string;
  surface: string;
  border: string;
  ink: string;
};

export const getIssuerDisplayName = ({ issuer_label, name }: { issuer: number; issuer_label?: string; name?: string }) =>
  [issuer_label, name]
    .map(label => typeof label === "string" ? label.trim() : "")
    .find(label => label) || "Card issuer";

const NEUTRAL_ISSUER_IDENTITY: IssuerIdentity = {
  accent: "#64748B",
  surface: "#F8FAFC",
  border: "#CBD5E1",
  ink: "#334155",
};

// A hand-picked cool palette keeps issuer context distinct without borrowing
// red, amber, or green semantics from error, warning, and success states.
const ISSUER_IDENTITIES: readonly IssuerIdentity[] = [
  {
    accent: "#2563EB",
    surface: "#EFF6FF",
    border: "#93C5FD",
    ink: "#1E3A8A",
  },
  {
    accent: "#0F766E",
    surface: "#F0FDFA",
    border: "#5EEAD4",
    ink: "#134E4A",
  },
  {
    accent: "#7C3AED",
    surface: "#F5F3FF",
    border: "#C4B5FD",
    ink: "#5B21B6",
  },
  {
    accent: "#0369A1",
    surface: "#F0F9FF",
    border: "#7DD3FC",
    ink: "#0C4A6E",
  },
  {
    accent: "#4338CA",
    surface: "#EEF2FF",
    border: "#A5B4FC",
    ink: "#312E81",
  },
  {
    accent: "#86198F",
    surface: "#FDF4FF",
    border: "#E879F9",
    ink: "#701A75",
  },
] as const;

export const getIssuerIdentity = (
  issuer: number | null | undefined,
): IssuerIdentity => {
  if (!Number.isInteger(issuer) || !issuer || issuer < 1)
    return NEUTRAL_ISSUER_IDENTITY;

  return ISSUER_IDENTITIES[(issuer - 1) % ISSUER_IDENTITIES.length];
};
